import React from "react";

const ActionButton = ({
  onClick,
  children,
  className = "",
  ariaLabel,
  ariaPressed,
  title,
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`action-btn ${className}`}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || children}
      aria-pressed={ariaPressed}
    >
      {children}
    </button>
  );
};

export default ActionButton;
